<template>
  <router-link
    v-if="normalizedRoute"
    tag="button"
    :to="normalizedRoute"
    class="ButtonTemplate"
  >
    <div>
      <slot />
    </div>
    <arrow-right-icon
      v-if="dir == 'ltr' && primary && showArrow"
      class="ButtonTemplate-icon arrow-icon"
    />
    <arrow-left-icon
      v-else-if="dir == 'rtl' && primary && showArrow"
      class="ButtonTemplate-icon arrow-icon"
    />
  </router-link>

  <button v-else :type="buttonType" class="ButtonTemplate">
    <span>
      <slot />
    </span>
    <arrow-right-icon
      v-if="dir == 'ltr' && primary && showArrow"
      class="ButtonTemplate-icon arrow-icon"
    />
    <arrow-left-icon
      v-else-if="dir == 'rtl' && primary && showArrow"
      class="ButtonTemplate-icon arrow-icon"
    />
  </button>
</template>

<script>
import { mapGetters } from 'vuex'
import ArrowLeftIcon from '@/assets/left-arrow.svg'
import ArrowRightIcon from '@/assets/arrow.svg'

export default {
  name: 'ButtonTemplate',
  components: { ArrowLeftIcon, ArrowRightIcon },
  props: {
    primary: Boolean,
    routeTo: String,
    showArrow: Boolean,
    buttonType: {
      type: String,
      default: 'button',
    },
  },
  computed: {
    ...mapGetters({
      dir: 'app/direction',
    }),
    normalizedRoute() {
      if (!this.routeTo) return null

      if (this.routeTo.startsWith('/')) return this.routeTo

      const trimmedRoute = this.routeTo.replace(/^\/+/, '')

      return `/${this.$i18n.locale}/${trimmedRoute}`
    },
  },
}
</script>

<style lang="scss" scoped>
.ButtonTemplate {
  @include font-category('button');
  @include flex-container(row, center, center);

  background: none;
  border: none;
  margin: 0;
  padding: 0;
}

.ButtonTemplate-icon {
  margin-top: 2px; // nudge down
  margin-left: 8px; // space between text
}

.arrow-icon {
  fill: currentColor;
  height: 16px;
  width: 16px;
}

html.is-rtl {
  .ButtonTemplate-icon {
    margin-right: 8px; // space between text
    margin-left: unset;
  }
}
</style>
